import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ReportsIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M15.0002 5.63379C15.0002 5.90987 14.7763 6.13369 14.5002 6.13379C14.2241 6.13379 14.0002 5.90993 14.0002 5.63379V3.70703L10.8538 6.85352C10.6633 7.04399 10.3564 7.04895 10.1594 6.86523L8.51196 5.32812L5.48754 8.35352C5.29228 8.54878 4.97577 8.54878 4.78051 8.35352C4.58525 8.15825 4.58525 7.84175 4.78051 7.64648L8.14672 4.28027L8.22289 4.21777C8.41201 4.09158 8.66867 4.10772 8.84106 4.26855L10.4875 5.80469L13.2932 3H11.5002C11.2241 3 11.0002 2.77614 11.0002 2.5C11.0002 2.22386 11.2241 2 11.5002 2H14.5002C14.7763 2.0001 15.0002 2.22392 15.0002 2.5V5.63379Z"
      fill="currentColor"
    />
    <path
      d="M4.5 2C4.77614 2 5 2.22386 5 2.5C5 2.77614 4.77614 3 4.5 3H2V13H14V10.5C14 10.2239 14.2239 10 14.5 10C14.7761 10 15 10.2239 15 10.5V13.5C15 13.7761 14.7761 14 14.5 14H1.5C1.22386 14 1 13.7761 1 13.5V2.5C1 2.22386 1.22386 2 1.5 2H4.5Z"
      fill="currentColor"
    />
  </svg>
);
